import { Component } from '@angular/core';
import { LoginControl } from 'app/_services/logincontrol.service';
import { Subscription } from 'rxjs';
import { LogService } from 'app/_services/logmanager.service';
import { Router } from '@angular/router';
import { AlertService } from 'app/_services/alert.service';
import { DataService } from 'app/_services/datamanager.service';
import { GlobalsService } from 'app/_services/globals.service';

@Component({
    selector: 'sec-sidebar',
    templateUrl: './sidebar.component.html'
})

export class SidebarComponent {
    errorMessage: string;
    subscription: Subscription;
    isloggedin = false;
    checkedsession = false;
    checkedsecretaria = false;
    menuNodes = <any>[];
    menuNodesSearchUser = <any>[];
    teMenu = false;
    view = false;
    admin = false;
    searchUser: string;
    sameUser = true;
    secretaria: string;

    constructor (
        private loginControl: LoginControl,
        private router: Router,
        private alertService: AlertService,
        private dataService: DataService,
        private globalStorage: GlobalsService
    ) {

        this.checkinfo();

        this.subscription = loginControl.isloggedin.subscribe(
            isloggedin => {
                this.isloggedin = isloggedin;
                this.checkinfo();
            });

        this.subscription = loginControl.checkedsession.subscribe(
            checkedsession => {
                this.checkedsession = checkedsession;
                this.checkinfo();
            });

        this.subscription = loginControl.checkedsecretaria.subscribe(
            checkedsecretaria => {
                this.checkedsecretaria = checkedsecretaria;
                this.checkinfo();
            });

        this.subscription = globalStorage.searchUser.subscribe(
            () => {
                this.isTheSameUser();
            }
        );

        router.events.subscribe((val) => {
            const isnavigationend = val.toString().includes('NavigationEnd');
            if (isnavigationend) {
               this.checkinfo();
            }
        });
    }

    checkinfo(debug = false) {
        LogService.log('SidebarComponent',  'checkinfo', debug);
        LogService.log('SidebarComponent',  'checkedsecretaria ' + this.checkedsecretaria, debug);
        LogService.log('SidebarComponent',  'checkedsession ' + this.checkedsession, debug);
        LogService.log('SidebarComponent',  'isloggedin ' + this.isloggedin, debug);

        // Mirar si s'ha seleccionat secretaria
        if (this.checkedsecretaria &&
            this.checkedsession &&
            this.isloggedin) {
            this.view = true;
        }

        if (this.view) {
            this.getMenuNodesUser();
            this.isTheSameUser();
            LogService.log('SidebarComponent',  'view', debug);
        } else {
            LogService.log('SidebarComponent',  'no view', debug);
        }

        this.secretaria = this.globalStorage.getItem('secretariaName');
    }

    isTheSameUser(): void  {
        const params = <any>{
            'accio': 'WsGetOwnID'
        };
        this.dataService.getData(params).subscribe(
            data => {
                this.sameUser = (!this.globalStorage.getItem('searchUser') || data[0] === this.globalStorage.getItem('searchUser'));
                if (!this.sameUser) {
                    this.getMenuNodesSearchUser();
                } else {
                    this.menuNodesSearchUser = [];
                }
                LogService.log('SidebarComponent',  'WsIsTheSameUser: ' + this.sameUser);
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            }
        );
    }

    getMenuNodesUser(): void {
        this.getMenuNodes(this.globalStorage.getItem('secretaria'));
    }

    getMenuNodesSearchUser(): void {
        this.getMenuNodes(this.globalStorage.getItem('secretaria'), this.globalStorage.getItem('searchUser'));
    }

    getMenuNodes(secretariaID: number, userID = 0) {
        const params = <any>{
            'accio': 'WsMenuNodes',
            'params': <any>{
                'user_id': userID,
                'secretaria_id' : secretariaID
            }
        };
        LogService.log('SidebarComponent',  'getMenuNodes getData returned');

        this.dataService.getData(params).subscribe(
            data => {
                LogService.log('SidebarComponent',  'getMenuNodes getData returned');

                if ('undefined' !== typeof(data[0])) {
                    LogService.log('SidebarComponent',  'menuNodes: ' + JSON.stringify(data[0]));

                    if (userID === 0) {
                        this.menuNodes = data[0];
                        this.teMenu = 'undefined' !== typeof(this.menuNodes[0]) && this.menuNodes[0]['nom_grup'] !== undefined;
                    } else {
                        this.menuNodesSearchUser = data[0];
                    }
                } else {
                    LogService.log('SidebarComponent',  data);
                }
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            }
        );
    }
}
